import React from 'react';
import "./Search.css";
import Assignment from '../../image/assignment.svg';
import Myjobcard from '../../image/myjobcard.svg';

function Search() {
  return (
    <div className="container">
         <div className="row">
            <div className="col-6">
              <form action="">
                <input type="search" className='choose_searchbox' placeholder="choose clients" />
              </form>
            </div>
            <div className="col-6">
              <form action="">
                <input type="search" className='choose_searchbox' placeholder="choose project" />
              </form>
            </div>
            <div className="icon_itemtect row">
            <div className="col-7">
              <div className="row job_card itemhover">
                <div className="col-2 itemiconsec">
                  <span className="itemsecbg  itemhover">
                  <img src={Assignment} alt="" className="itemicon" />
                  </span>
                </div>
                <div className="col-10">
                  <span className="cardtext">Job Card Assigned</span><br />
                  <span className="carditems">800</span>
                </div>
              </div>
            </div>

            <div className="col-4">
            <div className="row job_card itemhover">
                <div className="col-3 itemiconsec">
                  <span className="itemsecbg  itemhover">
                  <img src={Myjobcard} alt="" className="itemicon" />
                  </span>
                </div>
                <div className="col-9">
                  <span className="cardtext">My Job Card</span><br />
                  <span className="carditems">400</span>
                </div>
              </div>
            </div>
            </div>

          </div>
    </div>
  )
}

export default Search